import SaveIcon from '@mui/icons-material/Save';
import {useTranslation} from 'react-i18next';
import {Button, type ButtonProps} from '@mui/material';

export const SaveButton = (props: ButtonProps) => {
  const {t} = useTranslation('common');

  const {children, ...originalProps} = props;
  const buttonProps: ButtonProps = {
    endIcon: <SaveIcon />,
    variant: 'contained',
    ...originalProps,
  };

  return <Button {...buttonProps}>{children ?? t('save')}</Button>;
};
